import { RestRequest, RestContext, ResponseFunction } from 'msw'
import { requireAuthenticatedUser } from '../../decorators'

interface MockOperation {
  id: string
  status: 'pending' | 'running' | 'succeeded' | 'failed'
  operation_type: string
  request_id: string
  attempts: number
  max_attempts: number
  created_at: string
  updated_at: string
  completed_at: string | null
  result: { data: any } | { error: { type: string; message: string } } | null
  resolveAt: number
}

const operationStore = new Map<string, MockOperation>()

const MOCK_DELAY_MS = 2000

export function createMockOperation(
  operationType: string,
  resultData: any
): string {
  const id = crypto.randomUUID().replaceAll('-', '')
  const now = new Date().toISOString()
  operationStore.set(id, {
    id,
    status: 'pending',
    operation_type: operationType,
    request_id: crypto.randomUUID().replaceAll('-', ''),
    attempts: 1,
    max_attempts: 3,
    created_at: now,
    updated_at: now,
    completed_at: null,
    result: null,
    resolveAt: Date.now() + MOCK_DELAY_MS,
  })
  setTimeout(() => {
    const op = operationStore.get(id)
    if (op) {
      op.status = 'succeeded'
      op.completed_at = new Date().toISOString()
      op.updated_at = op.completed_at
      op.result = { data: resultData }
    }
  }, MOCK_DELAY_MS)
  return id
}

async function getOperation(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    return res(
      ctx.status(400),
      ctx.json({ message: 'Operation ID must be a string' })
    )
  }

  const op = operationStore.get(id)
  if (!op) {
    return res(ctx.status(404), ctx.json({ message: 'Operation not found' }))
  }

  const body = {
    data: {
      id: op.id,
      operation_id: op.id,
      status: op.status,
      operation_type: op.operation_type,
      request_id: op.request_id,
      attempts: op.attempts,
      max_attempts: op.max_attempts,
      created_at: op.created_at,
      updated_at: op.updated_at,
      completed_at: op.completed_at,
      result: op.result,
    },
  }

  if (op.status === 'succeeded' || op.status === 'failed') {
    return res(ctx.status(200), ctx.json(body))
  }

  return res(ctx.status(202), ctx.json(body))
}

export const handlers = [
  {
    method: 'get',
    path: '/api/operations/:id',
    handler: getOperation,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
